module.exports = __webpack_public_path__ + "static/media/logo_jeannedarc.9296e17f.png";